import React from 'react'

import pill from "./../../../UI/general/pill.svg"

interface Props {
    isVirtualTourActive: boolean,
    amenityData: any,
    handleCloseVirtualTour: any,
    colorsData: any,
}

interface State {
    isCollapsed: boolean,
    currentSelectedTour: string,
    currentSelectedtourIndex: number
}

class DetailedTour extends React.Component<Props,State>{

    constructor(props: Props){
        super(props);
        this.state = {
            isCollapsed: false,
            currentSelectedTour: "",
            currentSelectedtourIndex: 0
        }
    }

    componentDidMount(): void {
        this.setState({
            currentSelectedTour: this.props.amenityData.links[0].link
        })
    }


    handleChangeTour = (tour: any, index: number) => {
        this.setState({
            currentSelectedTour: tour,
            currentSelectedtourIndex: index
        })
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isVirtualTourActive ? 'detailed-tour-container fade-in':'detailed-tour-container fade-out'}>
                {
                    this.props.isVirtualTourActive ? 
                    <div className={this.state.isCollapsed ?'frame-container-wide':'frame-container'}>
                        <div className='iframe-container'>
                            <iframe src={this.state.currentSelectedTour} title="virtual-tours" width={"100%"} height="100%" style={{border: "none"}}/>
                        </div>
                    </div>:null
                }
                <div 
                    className={this.state.isCollapsed ? 'sidebar-tour-btn-collapsed':'sidebar-tour-btn'}
                    onClick={() => {this.props.handleCloseVirtualTour()}}
                >
                    <img src={pill} alt=""/>
                </div>
                <div className={this.state.isCollapsed ? 'sidebar-tour-container-collapsed':'sidebar-tour-container'}>
                    <div className='sidebar-tour-preview-container'>
                        {
                            this.props.amenityData && this.props.amenityData.links ?
                            this.props.amenityData.links.map((tours: any, index: number) => 
                                <div 
                                    className='individual-tour-container'
                                    onClick = {() => {
                                        this.handleChangeTour(tours.link, index)
                                    }}
                                >
                                    <div 
                                        className='individual-tour-image-container-alt'
                                        style={{
                                            backgroundColor:this.state.currentSelectedtourIndex === index ? this.props.colorsData.main_buttons:'transparent',
                                            color:this.state.currentSelectedtourIndex === index ? this.props.colorsData.secondary_text:this.props.colorsData.main_text,
                                        }}
                                        
                                    >
                                    <div 
                                    >
                                        {tours.name}
                                    </div>
                                    </div>

                                </div>
                            ):null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default DetailedTour